<script setup>
import OverviewText from './OverviewText.vue';
import LocationGrid from './LocationGrid.vue';
import LatestNews from '../LatestNews.vue';
import ContactForm from './ContactForm.vue';
</script>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            items: [],
        };
    },
    methods: {
        getNews() {
            axios.get('/api/home/news').then((response) => {
                this.$data.items = response.data.news;
            });
        },
    },
    mounted() {
        this.getNews();
    },
}
</script>

<template>
    <div class="tw-space-y-14">
        <div class="container pt-100px pb-100px py-50px-md py-100px-xl">
            <div class="tw-block md:tw-flex tw-flex-row">
                <OverviewText></OverviewText>
                <LocationGrid></LocationGrid>
            </div>
        </div>
        <section class="tw-relative">
            <LatestNews
                title="Latest News"
                description="We've built traditions and developed new inspirations for living. Our master-planned estates include residential and commercial spaces, built in mind for those who want to live, work, and play with everything they want and need within reach."
                button_text="MORE STORIES"
                :items="items"
            >
            </LatestNews>
        </section>
        <ContactForm></ContactForm>
    </div>
</template>
